import LoadingBar from '@/features/LoadingScreen/anexes/LoadingBar';
import { useEffect, useState } from 'react';
import DefaultLoader from './DefaultLoader';
import { useStore } from '@/store/useStore';

const MainLoader = ({
  type,
  isStuckedLoading,
  onAnimationFinish,
}: MainLoaderProps) => {
  // Track the displayed type (delayed update for transition effect)
  const [displayType, setDisplayType] = useState(type);

  // Derive isTransitioning from comparing current type with displayed type
  const isTransitioning = displayType !== type;
  const showLoadingBar = type === 'loading' || displayType === 'loading';
  const gameResetRevision = useStore((s) => s.gameResetRevision);

  useEffect(() => {
    if (displayType !== type) {
      const timer = setTimeout(() => {
        setDisplayType(type);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [type, displayType]);

  if (showLoadingBar) {
    return (
      <div
        className={`main-loader-wrapper ${
          isTransitioning ? 'transitioning' : ''
        }`}
      >
        <LoadingBar
          key={gameResetRevision}
          onAnimationFinish={onAnimationFinish}
          isStuckedLoading={isStuckedLoading}
        />
      </div>
    );
  }

  return <DefaultLoader isTransitioning={isTransitioning} />;
};

export default MainLoader;

export type MainLoaderProps = {
  type: string;
  isStuckedLoading: boolean;
  onAnimationFinish?: () => void;
  hasBottomBanner?: boolean;
  isLandscapeMobile?: boolean;
  themeData?: object;
  isBottomBanner?: boolean;
  isDefault?: boolean;
};
